import { faFileUpload } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { ReactElement, useCallback } from "react";
import { useDropzone } from "react-dropzone";
import { AttachmentsListGroup } from "../attachments";
import { Loading } from "../ui";
import { useProjects } from "./";

export const ProjectAttachmentsDropzone = (): ReactElement => {
	const projectContext = useProjects();

	const onDrop = useCallback(acceptedFiles => {
		projectContext.uploadFiles!(acceptedFiles);
	}, []);

	const { getRootProps, getInputProps, isDragActive } = useDropzone({
		onDrop,
	});

	if (!projectContext.project) {
		return <Loading />;
	}

	const project = projectContext.project;

	const attachmentList = project.attachments.length ? (
		<AttachmentsListGroup
			attachments={project.attachments}
			folder={`projects/${project.id}/`}
		/>
	) : (
		<div
			style={{
				display: "flex",
				height: "100%",
				justifyContent: "center",
				alignItems: "center",
			}}
		>
			<div style={{ textAlign: "center" }}>
				<FontAwesomeIcon
					icon={faFileUpload}
					size="5x"
					className="mb-4"
				/>
				<p>Drop files here to add them to this project.</p>
			</div>
		</div>
	);

	return (
		<div
			{...getRootProps({
				onClick: event => event.stopPropagation(),
			})}
			style={{ height: "100%", minHeight: 240 }}
		>
			<input {...getInputProps()} />
			{isDragActive ? <p>Drop the files here ...</p> : attachmentList}
		</div>
	);
};
